import { Navigate } from 'react-router-dom'

export function AdminLegacyCollectionRedirect() {
  return <Navigate to="/admin/edicoes" replace />
}
